import React, { PureComponent } from 'react';
import moment from 'moment'
import { createContainer } from '@dbk-legacy/muster/react';
import Button from '@dbk/ui-buttons';
import { Refresh } from '@dbk/ui-icons';
import { TextInput } from '@dbk/ui-forms';
import Slider from '@dbk/ui-slider';
import format from 'date-fns/format';
import Dropdown from '@dbk/ui-dropdowns';
import Text from '@dbk/ui-text';
import { FilterIcon } from '../../../../components/common/icons';
import TableRow from '../../../../components/common/table-row';
import { PALETTE, KEY_CODE } from '../../../../constants';
import CalendarModal from '../../../../components/common/calendar-modal';
import DateSelectionBar from '../../../../components/common/date-selection-bar';
import SimpleDate from '../../../../components/common/date';
import { convertStringArrayToObjectArray as convert, convertToDropDown } from '../../payment-utils';
import BlurModal from '../../../../components/common/blur-modal';
import Modal from '@dbk/ui-modal';
import { LoadingCircle } from '../../../../components/common/loading';
import { PAYMENTS } from '../../constant';
import findIndex from 'lodash/findIndex';
import { DatePicker, Calendar, Utils } from '@dbk/ui-datepicker';
import { View } from '@dbk/ui-react-utils';
import InverseProvider from '@dbk/ui-inverse';
import 'moment/min/locales';

const ICON_WDTH_HT = 20;
const today = moment().format('YYYY-MM-DD')
const weekAgo = moment().subtract(7, 'days').format('YYYY-MM-DD')
const monthAgo = moment().subtract(30, 'days').format('YYYY-MM-DD')
const initOpts = {
  currency: '',
  portfolio: '',
  debitAccount: '',
  beneficiaryName: '',
  paymentType: '',
  paymentStatus: '',
  selectedExecDate: '',
  execFromDate: null,
  execToDate: null,
  amountFrom: PAYMENTS.AMOUNT_MIN_RANGE,
  amountTo: PAYMENTS.AMOUNT_MAX_RANGE,
  filters: ['amount'],
  showFilter: false,
  isDateRangeActive: false,
}
const clearedFilters = {
  selectedExecDate: ' ',
  execFromDate: '',
  execToDate: '',
  amountFrom: PAYMENTS.AMOUNT_MIN_RANGE,
  amountTo: PAYMENTS.AMOUNT_MAX_RANGE,
  showFilter: true,
  dateRange: { from: null, to: null },
}

class PaymentFilter extends PureComponent {
  constructor(props) {
    super(props);
    const languageCode = this.props.auth.langCode;
    Utils.configLocale(languageCode, {
        week: {
            dow: 1, // Monday is the first day of the week.
            // dow: 0, // Sunday is the first day of the week.
        },
    });
  }

  state = Object.assign(
    {
      refetching: false,
      debitAccountListData: null,
      dateRange: {
        from: (this.props.payments.filterOptions && this.props.payments.filterOptions.execFromDate) ? moment(this.props.payments.filterOptions.execFromDate) : null,
        to: (this.props.payments.filterOptions && this.props.payments.filterOptions.execToDate) ? moment(this.props.payments.filterOptions.execToDate) : null
      },
      selectedDay: moment(this.props.payments.startDate)
    },
    initOpts,
    this.props.payments.filterOptions)


  componentDidUpdate(){
      if (this.props.reports.closeDatePicker === true && this.datepickerRef && this.datepickerRef.datepicker && this.datepickerRef.datepicker.state && this.datepickerRef.datepicker.state.isOpen ) {
        this.onCancel();
      }
      if(document.querySelector('input.searchInput') && this.state.beneficiaryName){
        document.querySelector('input.searchInput').focus();
        return;
      }
      // if(document.querySelector('button.paymentFilterFocus')){  // Button focusable for payment filter popup
      //   document.querySelector('button.paymentFilterFocus').focus();
      // }
    }
    componentDidMount(){    //WMCE-45985-to resolve -Payment-filter-date-range for german language
     this.setState({
      execFromDate: '',
      execToDate: '',
      dateRange: {
        from: null,
        to: null
      }})
      if(document.querySelector('button.paymentFilterFocus')){  // Button focusable for payment filter popup
        document.querySelector('button.paymentFilterFocus').focus();
      }
    }

  onCancel = () => {
      this.datepickerRef.datepicker.closeCalendar();
      this.props.setDatePickerClose(false);
  }


  onFilterChange = (key, value) => {
    this.setState({ [key]: value })
    this.setFilter(key, value)
  }

  onPortfolioChange = (option) => {
    const { payments } = this.props;
    this.onFilterChange('portfolio', option);
    const debitAccountListData = option != "" ? payments.debitAccountListData.filter((p) => p.pfId.includes(option)) : payments.debitAccountListData;
    this.setState({ debitAccountListData }, function () {
      const debitIndex = findIndex(debitAccountListData, (p) => p.psActNo === this.state.debitAccount);
      if (debitIndex == -1)
        this.onFilterChange('debitAccount', '');
    });
  }
  onClearClick = () => {
    const { payments: { setFilterFlag, setFilterOptions, setFilteredPayments, debitAccountListData } } = this.props;
    this.setState(prevState => ({
      ...initOpts,
      ...clearedFilters,
      filters: ['amount'],
      debitAccountListData
    }))
    setFilterFlag(false);
    setFilterOptions(null);
    setFilteredPayments(null);
  }
  onAmountChange = ({ min, max }) => {
    this.setState({ amountFrom: min })
    this.setState({ amountTo: max })
  }
  onApplyClick = () => {
    const { payments: { setFilterOptions } } = this.props;
    const {
      filters, amountFrom, amountTo, execFromDate, execToDate, selectedExecDate } = this.state;
    const options = {};
    options.selectedExecDate = selectedExecDate;
    for (const filter of filters) {
      if (filter === 'amount') {
        options.amountFrom = amountFrom
        options.amountTo = amountTo
      } else if (filter === 'date') {
        if (selectedExecDate === 'range') {
          options.execFromDate = moment(execFromDate,"DD MMM. YYYY").format('YYYY-MM-DD'); //WMCE-45985-For resolving the payment filter in case of german language. 
          options.execToDate = moment(execToDate , "DD MMM. YYYY").format('YYYY-MM-DD');
        } else {
          options.execFromDate = execFromDate;
          options.execToDate = execToDate;
        }
      } else options[filter] = this.state[filter];
    }
    options.filters = this.state.filters;
    this.props.payments.applyFilter(options);
    this.toggleFilter(false, options);
  }
  setExecDate = execDate => {
    let execFromDate
    if (execDate === 'today') {
      execFromDate = today
    } else if (execDate === 'oneWeek') {
      execFromDate = weekAgo
    } else if (execDate === 'oneMonth') {
      execFromDate = monthAgo
    }
    if (execDate !== 'range') {
      this.setState({
        selectedExecDate: execDate,
        execFromDate,
        execToDate: today,
        dateRange: {
          from: execFromDate ? moment(execFromDate) : null,
          to: moment()
        }
      });
    } else {
      this.setState({
        selectedExecDate: execDate,
        isDateRangeActive: true,
      })
    }
    if (!this.state.filters.includes('date')) {
      this.setState(prevState => ({
        ...prevState,
        filters: prevState.filters.concat('date')
      }))
    }
  }
  setFilter = (filterType, value) => {
    const { filters } = this.state;
    if (!filters.includes(filterType)) {
      filters.push(filterType);
      this.setState({ filters });
    } else if (filters.includes(filterType) && value === '') {
      filters.splice(filters.indexOf(filterType), 1);
      this.setState({ filters });
    }
  }
  refetch = async (e) => {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      console.log("in refetch...");
      if (this.state.refetching || this.props.payments.transactionListLoading) return;
        this.setState({ refetching: true })
        await this.props.payments.getPaymentHistory('refetch');
        setTimeout(() => {
          this.setState({ refetching: false })
        }, 100);
    }
  }
  toggleFilter = (show, options, e) => {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      this.setState({ showFilter: show }, async function () {
        if (show) {
          this.props.payments.setFilterDataSource();
        }
        else {
          const filterOptions = (options.filters) ? options : this.props.payments.filterOptions;
          const obj = Object.assign(
            {},
            initOpts,
            filterOptions)
          this.setState({
            ...obj,
            filters: filterOptions ? filterOptions.filters : ['amount']
          })
        }
      })
      setTimeout(() =>{
        if(document.querySelector('button.paymentFilterFocus')){  // Button focusable for payment filter popup
          document.querySelector('button.paymentFilterFocus').focus();
        }
      }, 1000)
    }
  }

  hideDateRangeModal = () => {
    const { execFromDate, execToDate } = this.state;
    this.setState(() => ({
      // isDateRangeActive: false,
      dateRange: {
        from: execFromDate ? moment(execFromDate) : null,
        to: execToDate ? moment(execToDate) : null
      }
    }));
    this.datepickerRef.datepicker.closeCalendar();
    // this.datepickerRef.handleClose();
  };

  onDateApply = () => {
    // this.hideDateRangeModal();
    const { dateRange } = this.state;
    this.setState({
      execFromDate: dateRange.from ? moment(dateRange.from).format('DD MMM YYYY') : null,
      execToDate: dateRange.to ? moment(dateRange.to).format('DD MMM YYYY') : null,
      // isDateRangeActive: false,
    });
    this.datepickerRef.datepicker.closeCalendar();
  }


  // onDayClick = (selectionStart) => {
  //   const value = Utils.addDayToRange(selectionStart, this.state.dateRange);
  //   this.setState({
  //     dateRange: value,
  //   });
  // }

  onChangeRange = (range) => {
    this.setState({
      dateRange: {
        ...Utils.updateRangeWithReset(this.state.dateRange, range)
      }
    });
  };

  customFooter = () => {
    const { i18n: { messages } } = this.props;
    const { dateRange: { from, to } } = this.state;
    return <InverseProvider inverse className="customFooterParent">
        <div className="datepicker-footer-txt">
            <Text className="customFooterToday">{messages['app.chedelivery.reports.customReports.today']}{moment().format('DD-MMM-YYYY')}</Text>
        </div>
        <div className="datepicker-footer-btn">
            <Button tertiary
                onClick={() => this.hideDateRangeModal()}
            >{messages['app.chedelivery.reports.customReports.cancelButton']}</Button>

            <Button
                onClick={() => this.onDateApply()}
                disabled={!(from && to)}
            >{messages['app.chedelivery.reports.apply']}</Button>
        </div>
    </InverseProvider>
}

onCancel = () => {
  this.datepickerRef.datepicker.closeCalendar();
}
  render() {
    const {
      i18n: { messages },
      payments: {
        portfolioListData,
        paymentTypeListData,
        currencyListData,
        statusListData,
        debitAccountListData,
      },
      auth, } = this.props;
    const {
      beneficiaryName,
      amountFrom,
      amountTo,
      selectedExecDate,
      filters,
      showFilter,
      execFromDate,
      execToDate,
      dateRange,
    } = this.state;

    const languageCode = (auth.langCode) ? auth.langCode.toLowerCase() : 'en';
    const filterLength = filters.length;
    const showToDate = '';
    const isLoaded = portfolioListData && this.props.payments.debitAccountListData && paymentTypeListData && currencyListData && statusListData;

    const filterLabelStyle = {
      margin: 10,
      color: PALETTE.secondaryActive,
    };
    const labelStyle = {
      color: PALETTE.secondaryText,
      marginBottom: 10
    };
    const labelColor = {
      color: PALETTE.secondaryText
    }

    const searchIconStyle = {
      marginLeft: 5
    }

    const currencyData = convert(currencyListData);
    const portfolioData = convert(portfolioListData);
    const debitAccountData = convertToDropDown((debitAccountListData || this.props.payments.debitAccountListData), ["psActNo"]);
    const paymentTypeData = convert(paymentTypeListData);
    const paymentStatusData = convert(statusListData);
    const pageTitle = `${messages['app.payment.pageTitle.filterPayment']} (${filterLength})`;
    return (
      <div>
        <div className="nav-icon-group">
          <span className="nav-icon-group-pass">
            <span className={'margin-left-20 pointer'} role="button" onKeyDown={(e) =>this.refetch(e)} onClick={() => this.refetch()} tabIndex="0" aria-label={messages['app.payment.refreshButton']}>
              <Refresh id="refresh" width={22} height={25} color={PALETTE.primaryText} />
            </span>
            <span className={'margin-left-20 pointer'} role="button" onKeyDown={(e) =>this.toggleFilter(true, "", e)} onClick={() => this.toggleFilter(true)} tabIndex="0" aria-label={messages['app.payment.filterButton']}>
              <FilterIcon id="filter" width={22} height={25} color={PALETTE.primaryText} />
            </span>
          </span>
        </div>
        <BlurModal
          onDone={() => this.setState({ showFilter: false })}
          visible={showFilter}
          type="xdark"
          size="large"
          title={pageTitle}
        >
          <div className="payment-filter-input">
            {!isLoaded && <LoadingCircle />}
            {isLoaded && <div className="row" >
              <div className="columns large-12 pymntFilterContentBgCol">
                <div className="row">
                  <Text className="columns large-12" style={labelStyle} tabIndex="0" aria-label={messages['app.payment.filter.pymtExecDateFilter']}> {messages['app.payment.filter.pymtExecDate']} </Text>
                </div>
                <div className="row">
                  <div className="btn_seg columns large-3">
                    <Button
                      tabIndex={0}
                      className="paymentFilterFocus"
                      onPress={() => this.setExecDate('today')}
                      tertiary={selectedExecDate !== 'today'}
                      fullWidth>
                      {messages['app.payment.filter.today']}
                    </Button>
                  </div>
                  <div className="btn_seg columns large-3">
                    <Button
                      className="paymentFilterFocus"
                      tertiary={selectedExecDate !== 'oneWeek'}
                      fullWidth
                      onPress={() => this.setExecDate('oneWeek')} >
                      {messages['app.payment.filter.oneWeek']}
                    </Button>
                  </div>
                  <div className="btn_seg columns large-3" >
                    <Button
                      className="paymentFilterFocus"
                      tertiary={selectedExecDate !== 'oneMonth'}
                      fullWidth
                      onPress={() => this.setExecDate('oneMonth')}>
                      {messages['app.payment.filter.oneMonth']}
                    </Button>
                  </div>
                  <div className="btn_tabView">
                    <div className="btn_seg columns large-3">
                      <Button
                        tabIndex="0"
                        className="paymentFilterFocus"
                        tertiary={selectedExecDate !== 'range'}
                        fullWidth
                        onPress={() => this.setExecDate('range')} >
                        {messages['app.payment.filter.range']}
                      </Button>
                    </div>
                  </div>
                  {this.state.isDateRangeActive &&
                  <div className="paymentFilter" aria-label={messages['app.payment.dateRangeCalender']} >
                        <DatePicker
                        aria-label={messages['app.payment.dateRangeCalender']}
                          ref={(ref) => this.datepickerRef = ref}
                          showOutsideMonthDays={false}
                          enableYearNavigation
                          enableRangeSelection
                          onChange={this.onChangeRange}
                          value={dateRange}
                          startDate={moment().add(-2, 'years')}
                          endDate={moment().add(4, 'years')}
                          inputDateFormat={'DD MMM YYYY'}
                          selectionStart={dateRange.from}
                          selectionEnd={dateRange.to}
                          disableWeekendDays
                          renderFooter={() => this.customFooter()} />
                      </div>
                  }
                </div>
                <div className="row">
                  <Text className="columns large-12" style={labelColor} tabIndex="0"> {messages['app.payment.filter.pymtAmount']}</Text>
                  <div className="columns large-12"
                  aria-label={messages['app.payments.amountSelection']}>
                  {/* <Text className="columns large-12" style={labelColor} > {messages['app.payment.filter.pymtAmount']} </Text>
                  <div className="columns large-12" tabIndex={0}> */}
                    <Slider
                      value={{ min: amountFrom, max: amountTo }}
                      onChange={this.onAmountChange}
                      minValue={PAYMENTS.AMOUNT_MIN_RANGE}
                      maxValue={PAYMENTS.AMOUNT_MAX_RANGE}
                      showCurrentLabel
                    />
                  </div>
                </div>
                <div className="row filterRowsMargin">
                  <div className="columns large-6">
                    <div>
                      <Text style={labelStyle} tabIndex={0}> {messages['app.payment.filter.pymtCurrency']} </Text>
                    </div>
                    <div aria-label={messages['app.payment.filter.pymtCurrencyDropdown']}>
                      <Dropdown
                        tabIndex="0" 
                        className='customDropDownFilter'
                        size='large'
                        fullWidth
                        selected={this.state.currency}
                        options={currencyData}
                        defaultLabel={messages['app.payment.filter.selectCurrency']}
                        onChange={(option) => {
                          this.onFilterChange('currency', option);
                        }}
                      />
                    </div>
                  </div>
                  <div className="columns large-6">
                    <div>
                      <Text style={labelStyle} tabIndex={0}> {messages['app.payment.filter.portfolio']} </Text>
                    </div>
                    <div aria-label={messages['app.payment.filter.selectPortfolioDropdown']}>
                      <Dropdown
                        tabIndex="0"
                        className='customDropDownFilter'
                        size='large'
                        fullWidth
                        selected={this.state.portfolio}
                        options={portfolioData}
                        defaultLabel={messages['app.payment.filter.selectPortfolio']}
                        onChange={(option) => {
                          this.onPortfolioChange(option);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="row filterRowsMargin">
                  <div className="columns large-6 ">
                    <div>
                      <Text style={labelStyle} tabIndex={0}> {messages['app.payment.filter.debitAccount']} </Text>
                    </div>
                    <div aria-label={messages['app.payment.filter.debitAccountDropdown']}>
                      <Dropdown
                        tabIndex="0"
                        className='customDropDownFilter'
                        size='large'
                        fullWidth
                        selected={this.state.debitAccount}
                        options={debitAccountData}
                        defaultLabel={messages['app.payment.filter.selectAccount']}
                        onChange={(option) => {
                          this.onFilterChange('debitAccount', option);
                        }}
                      />
                    </div>
                  </div>
                  <div className="columns large-6 ">
                    <div>
                      <Text style={labelStyle} tabIndex={0}> {messages['app.payment.filter.beneName']} </Text>
                    </div>
                    <div className='customDropDownFilter'>
                      <TextInput
                        tabIndex="0"
                        value={beneficiaryName}
                        size="small"
                        placeholder={messages['app.payment.filter.selectBeneName']}
                        placeholderTextColor={PALETTE.primaryText}
                        onChange={text => this.onFilterChange('beneficiaryName', text.target.value)}
                        className="searchInput"
                      />
                    </div>
                  </div>
                </div>
                <div className="row filterRowsMargin">
                  <div className="columns large-6 ">
                    <div>
                      <Text style={labelStyle} tabIndex={0}> {messages['app.payment.filter.pymtType']} </Text>
                    </div>
                    <div aria-label={messages['app.payment.filter.pymtTypeDropdown']}>
                      <Dropdown
                        tabIndex="0"
                        className='customDropDownFilter'
                        size='large'
                        fullWidth
                        selected={this.state.paymentType}
                        options={paymentTypeData}
                        defaultLabel={messages['app.payment.filter.selectPaymentType']}
                        onChange={(option) => {
                          this.onFilterChange('paymentType', option);
                        }}
                      />
                    </div>
                  </div>
                  <div className="columns large-6 ">
                    <div>
                      <Text style={labelStyle} tabIndex={0}> {messages['app.payment.filter.pymtStatus']} </Text>
                    </div>
                    <div aria-label={messages['app.payment.filter.pymtStatusDropdown']}>
                      <Dropdown
                        tabIndex="0"
                        className='customDropDownFilter'
                        size='large'
                        fullWidth
                        selected={this.state.paymentStatus}
                        options={paymentStatusData}
                        defaultLabel={messages['app.payment.filter.selectPaymentStatus']}
                        onChange={(option) => {
                          this.onFilterChange('paymentStatus', option);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="row ">
                  <div className="btn">
                    <Button size="large" onPress={this.onApplyClick}>
                      {messages['app.payment.filter.applyButton']}
                    </Button>
                  </div>
                  <div className="btn">
                    <Button size="large" tertiary onPress={this.onClearClick}>
                      {messages['app.payment.filter.clearButton']}
                    </Button>
                  </div>
                </div>
              </div>
          </div>}
        </div>
        </BlurModal>
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    payments: {
      getPaymentHistory: { $call: 'getPaymentHistory' },
      transactionListLoading: true,
      setFilterFlag: { $set: 'filterFlag' },
      portfolioListData: true,
      debitAccountListData: true,
      paymentTypeListData: true,
      statusListData: true,
      currencyListData: true,
      filterOptions: true,
      applyFilter: { $call: 'applyFilter' },
      setFilterOptions: { $set: 'filterOptions' },
      setFilteredPayments: { $set: 'filteredPayments' },
      setFilterDataSource: { $call: 'setFilterDataSource' }
    },
    auth: {
      langCode: true,
    },
    reports:{
      closeDatePicker:true
    },
    setDatePickerClose: {
      $set: 'reports.closeDatePicker'
    },
  },
}
)(PaymentFilter);
